import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Collapse as MuiCollapse } from '@material-ui/core';
const easeOutTimingFunction = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const Collapse = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    return /*#__PURE__*/ _jsx(MuiCollapse, _object_spread_props(_object_spread({}, props), {
        style: _object_spread({
            transitionTimingFunction: easeOutTimingFunction
        }, props.style),
        ref: ref
    }));
});
